import { useCallback } from "react";
import { useRefresh } from "ra-core";

/**
 * Returns a refresh function that fires immediately and then again after a
 * delay. Used to pick up async side-effects (e.g. the calculate_load edge
 * function triggered by a DB trigger) that write back to the load record a
 * moment after the original write completes.
 */
export const useDelayedRefresh = (delayMs = 2500) => {
  const refresh = useRefresh();
  return useCallback(() => {
    refresh();
    setTimeout(refresh, delayMs);
  }, [refresh, delayMs]);
};
